import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import MCAParameterUpdateModalUI from './MCAParameterUpdateModalUI.js'

class MCAParameterUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      financialYear: '',
      financialYearError: null,
      parameterValue: '',
      parameterValueError: null
    }
  }

  render() {
    return (
      <MCAParameterUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        financialYear={this.state.financialYear}
        onFinancialYearChange={(event) => this.setState({ financialYear: event.target.value })}
        financialYearError={this.state.financialYearError}
        setFinancialYearError={(error) => { this.setState({ financialYearError: error }) }}
        yearList={this.props.yearList}
        //
        parameterValue={this.state.parameterValue}
        onParameterValueChange={(event) => this.setState({ parameterValue: event.target.value })}
        parameterValueError={this.state.parameterValueError}
        setParameterValueError={(error) => { this.setState({ parameterValueError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/mca/reportTypes/${this.props.reportType}/parameters/${this.props.selectedParameterName}`,
      this.onSubmitCallback, {
      financialYear: this.state.financialYear,
      parameterValue: this.state.parameterValue
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(MCAParameterUpdateModalSF)
